import React from "react";
import { HOME_SECTION_BACKGROUND_URL } from "../constants/homeSectionBackground";
import { useTranslation } from "../i18n/useTranslation";

const CDN = "https://pub-dd11db53b680447d86c08d43682efe32.r2.dev";

const icon = (file: string) => `${CDN}/icons/${encodeURIComponent(file)}`;

type Card = {
  titleKey: "home.featureIllustrationsTitle" | "home.featureLanguagesTitle" | "home.featureInclusiveTitle";
  bodyKey: "home.featureIllustrationsBody" | "home.featureLanguagesBody" | "home.featureInclusiveBody";
  iconFile: string;
};

const cards: Card[] = [
  {
    titleKey: "home.featureIllustrationsTitle",
    bodyKey: "home.featureIllustrationsBody",
    iconFile: "pictures.png",
  },
  {
    titleKey: "home.featureLanguagesTitle",
    bodyKey: "home.featureLanguagesBody",
    iconFile: "language.png",
  },
  {
    titleKey: "home.featureInclusiveTitle",
    bodyKey: "home.featureInclusiveBody",
    iconFile: "story.png",
  },
];

const FeaturesStrip: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section
      id="made-for-your-family"
      className="relative z-10 scroll-mt-20 overflow-hidden bg-brandBeige px-4 py-11 sm:px-6 sm:py-16"
      aria-labelledby="home-features-heading"
    >
      <img
        src={HOME_SECTION_BACKGROUND_URL}
        alt=""
        className="pointer-events-none absolute inset-0 h-full w-full object-cover object-center"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute inset-0 bg-gradient-to-b from-white/35 via-white/10 to-brandBeige/25"
        aria-hidden
      />
      <div className="relative z-10 mx-auto max-w-6xl">
        <h2
          id="home-features-heading"
          className="mb-3 bg-gradient-to-r from-brandNavy via-brandOrange to-brandBlue bg-clip-text px-1 text-center text-[1.625rem] font-extrabold leading-tight text-transparent sm:text-3xl sm:px-0 md:text-4xl"
        >
          {t("home.featuresTitle")}
        </h2>
        <ul className="grid grid-cols-1 gap-8 md:grid-cols-3 md:gap-10">
          {cards.map((card) => (
            <li
              key={card.titleKey}
              className="flex flex-col items-center text-center"
            >
              <img
                src={icon(card.iconFile)}
                alt=""
                className="mb-4 h-24 w-24 object-contain sm:h-28 sm:w-28 drop-shadow-[0_6px_12px_rgba(64,89,107,0.14)]"
                width={112}
                height={112}
                aria-hidden
              />
              <h3 className="mb-2 text-lg font-extrabold text-brandNavy sm:text-xl">
                {t(card.titleKey)}
              </h3>
              <p className="max-w-sm text-sm leading-relaxed text-brandNavy/90 sm:text-base">
                {t(card.bodyKey)}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default FeaturesStrip;
